import {
  HTTP_LOADBUDGETFA_FETCHING,
  HTTP_LOADBUDGETFA_SUCCESS,
  HTTP_LOADBUDGETFA_FAILED,
} from "src/Constants";

const initialState = {
  result: null,
  isFeaching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_LOADBUDGETFA_FETCHING:
      return { ...state, result: null, isFeaching: true, isError: false };
    case HTTP_LOADBUDGETFA_SUCCESS:
      return { ...state, result: payload, isFeaching: false, isError: false };
    case HTTP_LOADBUDGETFA_FAILED:
      return { ...state, result: null, isFeaching: false, isError: true };
    default:
      return state;
  }
};
